// Red-banner texts shared by the Sales, Purchasing, Finance and Customer/Supplier forms,
// so every module words its errors the same way. Each field shows its own
// reason, so the banner only points to them.
export const FIX_FIELDS_MESSAGE = "Please fix the fields marked in red.";

// Field messages, worded the same way in every module (and as the server words them).
export const requiredMessage = (label) => `${label} is required.`;
export const positiveMessage = (label) => `${label} must be greater than 0.`;
export const NO_ITEMS_MESSAGE = "At least one line item must be added.";
// A line-item message says which row it is about, e.g. "Row 2: Unit is required."
export const rowMessage = (index, message) => `Row ${index + 1}: ${message}`;

// A row-level reason from the server ("items.0") has no field of its own.
const isRowKey = (key) => /^items\.\d+$/.test(key);

/**
 * Banner text for a failed save.
 * - The server named the fields → they show the reasons; the banner points to them.
 *   Reasons the form has no field for (canShowField returns false) are spelled out.
 * - No fields named (e.g. a network or permission problem) → the server's reason.
 */
export function saveFailedMessage(docType, err, canShowField = (key) => !isRowKey(key)) {
    const failed = `Failed to save ${docType.toLowerCase()}.`;
    const fields = err?.fields && typeof err.fields === "object" ? err.fields : {};
    const keys = Object.keys(fields);
    if (!keys.length) return err?.message ? `${failed} (${err.message})` : failed;

    const unshown = keys.filter((key) => !canShowField(key)).map((key) => fields[key]);
    const pointer = unshown.length < keys.length ? ` ${FIX_FIELDS_MESSAGE}` : "";
    return `${failed}${unshown.length ? ` ${unshown.join(" ")}` : ""}${pointer}`;
}
